<template>
    <span class="ep-spinner" :class="{'dark': isDark}" :style="{height, width: height}"></span>
</template>

<script>
// todo: pass border width as prop
export default {
    name: 'EpSpinner',

    // think about width also
    props: {
        height: {
            type: String,
            default: '2rem',
        },

        isDark: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
